/**
 * Tour Steps Configuration
 * Defines the sequence and content of the product tour
 * 
 * SIMPLIFIED VERSION - Stakeholder Map steps removed
 */

export interface TourStep {
  target: string;
  content: string;
  title: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
  disableBeacon?: boolean;
  route?: string;
}

export const tourSteps: TourStep[] = [
  {
    target: '[data-tour="sidebar-dashboard"]',
    content: 'Welcome to HEAT! This is your Dashboard — the central hub for strategic intelligence. Let\'s take a quick tour of the key features.',
    title: 'Welcome to HEAT!',
    placement: 'right',
    disableBeacon: true,
    route: '/dashboard',
  },
  {
    target: '[data-tour="daily-briefing-card"]',
    content: 'Each day, our AI analyzes all relevant news, stakeholder movements, and issue developments to provide you with a concise executive summary. Click "View Full Briefing" to dive deeper.',
    title: 'Your Daily Briefing',
    placement: 'bottom',
    route: '/dashboard',
  },
  {
    target: '[data-tour="sidebar-monitoring"]',
    content: 'The Monitoring section tracks all relevant media coverage and scores articles based on their relevance and sentiment to your organization.',
    title: 'Media Monitoring',
    placement: 'right',
    route: '/monitoring',
  },
  {
    target: '[data-tour="monitoring-analytics-tab"]',
    content: 'Switch to the Analytics tab to view sentiment distribution and trends over time. This helps you understand how media coverage is evolving.',
    title: 'Sentiment Analytics',
    placement: 'bottom',
    route: '/monitoring',
  },
  {
    target: '[data-tour="sidebar-issues"]',
    content: 'The Issues section helps you track and manage strategic issues affecting your organization. Each issue is prioritized and linked to relevant stakeholders.',
    title: 'Issue Tracking',
    placement: 'right',
    route: '/issues',
  },
  {
    target: '[data-tour="sidebar-stakeholders"]',
    content: 'Here you\'ll find all stakeholders relevant to your organization, with their influence levels, interest levels, and relationship status. That\'s the end of the tour — enjoy using HEAT!',
    title: 'Stakeholder Directory',
    placement: 'right',
    route: '/stakeholders',
  },
];
